export default __webpack_public_path__ + "static/media/info.f1b8af12.svg";